import { CivilLawSubjectType, RoleInCompanyType } from 'api/types/entity';
import { SaveRoleInCompanyParam } from 'api/types/params/onboarding/saveRoleInCompanyParam';
import { isFinanceProject } from 'config';

import { RoleInCompanyFormType } from '../../forms/roleInCompanyForm';

export const getSubmitData = (
  values: RoleInCompanyFormType
): SaveRoleInCompanyParam => {
  const civilLawSubject = isFinanceProject()
    ? values.civilLawSubject?.value
    : CivilLawSubjectType.PhysicalPerson;

  return {
    roleInCompany: values.role?.value!,
    authorityConfirmationDocument: {
      dateOfExpiration: values.dateOfExpiration ?? undefined,
      dateOfIssue: values.dateOfIssue,
      fileIds: values.fileIds,
      number: values.number,
    },
    civilLawSubject:
      values.role?.value === RoleInCompanyType.AuthorizedRepresentative
        ? civilLawSubject
        : undefined,
  };
};
